<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>广告管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 主要内容 start -->
    <div class="main_container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="常用广告位内容管理" name="first">
          <el-tabs
            type="card"
            v-model="activeChildName"
            @tab-click="handleClickChild"
          >
            <el-tab-pane label="banner管理" name="2">
              <div
                class="list_wrap list_wrap_child"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
                <template v-if="bannerList.length > 0">
                  <div
                    class="item_wrap"
                    v-for="item in bannerList"
                    :key="item.id"
                  >
                    <div class="item_main_wrap flex-rowl">
                      <div class="content_wrap flex-between">
                        <div class="pic_box">
                          <el-image :src="item.pic" fit="contain">
                            <div slot="error" class="image-slot flex-rowc">
                              <i class="iconfont icon-zanwutupian1"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="intro_box flex-rowl">
                          <div class="block">
                            <p>
                              名称：<span>{{ item.topic }}</span>
                            </p>
                            <p>{{ item.siteinstr }}</p>
                            <p>
                              跳转类型：<span>{{ item.gotypestr }}</span>
                            </p>
                          </div>

                          <div class="block">
                            <p>
                              排序：<span>{{ item.sortno }}</span>
                            </p>
                            <p>
                              状态：<span>{{
                                item.astate ? item.astate : "停用"
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                        <div
                          class="editBtn"
                          @click="handleGo(item.id, 'adverBnnaer', 2)"
                        >
                          编辑banner→
                        </div>
                      </div>
                    </div>
                    <div class="shop_more"></div>
                  </div>
                </template>
                <el-empty
                  description="暂无数据"
                  v-if="!loading && bannerList.length == 0"
                ></el-empty>
              </div>
            </el-tab-pane>
            <el-tab-pane label="商品列表页banner" name="3">
              <div
                class="list_wrap list_wrap_child"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
                <template v-if="bannerList.length > 0">
                  <div
                    class="item_wrap"
                    v-for="item in bannerList"
                    :key="item.id"
                  >
                    <div class="item_main_wrap flex-rowl">
                      <div class="content_wrap flex-between">
                        <div class="pic_box">
                          <el-image :src="item.pic" fit="contain">
                            <div slot="error" class="image-slot flex-rowc">
                              <i class="iconfont icon-zanwutupian1"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="intro_box flex-rowl">
                          <div class="block">
                            <p>
                              名称：<span>{{ item.topic }}</span>
                            </p>
                            <p>{{ item.siteinstr }}</p>
                            <p>
                              跳转类型：<span>{{ item.gotypestr }}</span>
                            </p>
                          </div>

                          <div class="block">
                            <p>
                              排序：<span>{{ item.sortno }}</span>
                            </p>
                            <p>
                              状态：<span>{{
                                item.astate ? item.astate : "停用"
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                        <div
                          class="editBtn"
                          @click="handleGo(item.id, 'adverBnnaer', 2)"
                        >
                          编辑banner→
                        </div>
                      </div>
                    </div>
                    <div class="shop_more"></div>
                  </div>
                </template>
                <el-empty
                  description="暂无数据"
                  v-if="!loading && bannerList.length == 0"
                ></el-empty>
              </div>
            </el-tab-pane>
            <el-tab-pane label="eventbanner" name="4">
              <div
                class="list_wrap list_wrap_child"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
                <template v-if="bannerList.length > 0">
                  <div
                    class="item_wrap"
                    v-for="item in bannerList"
                    :key="item.id"
                  >
                    <div class="item_main_wrap flex-rowl">
                      <div class="content_wrap flex-between">
                        <div class="pic_box">
                          <el-image :src="item.pic" fit="contain">
                            <div slot="error" class="image-slot flex-rowc">
                              <i class="iconfont icon-zanwutupian1"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="intro_box flex-rowl">
                          <div class="block">
                            <p>
                              名称：<span>{{ item.topic }}</span>
                            </p>
                            <p>{{ item.siteinstr }}</p>
                            <p>
                              跳转类型：<span>{{ item.gotypestr }}</span>
                            </p>
                          </div>

                          <div class="block">
                            <p>
                              排序：<span>{{ item.sortno }}</span>
                            </p>
                            <p>
                              状态：<span>{{
                                item.astate ? item.astate : "停用"
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                        <div
                          class="editBtn"
                          @click="handleGo(item.id, 'adverBnnaer', 2)"
                        >
                          编辑banner→
                        </div>
                      </div>
                    </div>
                    <div class="shop_more"></div>
                  </div>
                </template>
                <el-empty
                  description="暂无数据"
                  v-if="!loading && bannerList.length == 0"
                ></el-empty>
              </div>
            </el-tab-pane>
            <el-tab-pane label="活动列表页顶部小banner" name="5">
              <div
                class="list_wrap list_wrap_child"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
                <template v-if="bannerList.length > 0">
                  <div
                    class="item_wrap"
                    v-for="item in bannerList"
                    :key="item.id"
                  >
                    <div class="item_main_wrap flex-rowl">
                      <div class="content_wrap flex-between">
                        <div class="pic_box">
                          <el-image :src="item.pic" fit="contain">
                            <div slot="error" class="image-slot flex-rowc">
                              <i class="iconfont icon-zanwutupian1"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="intro_box flex-rowl">
                          <div class="block">
                            <p>
                              名称：<span>{{ item.topic }}</span>
                            </p>
                            <p>{{ item.siteinstr }}</p>
                            <p>
                              跳转类型：<span>{{ item.gotypestr }}</span>
                            </p>
                          </div>

                          <div class="block">
                            <p>
                              排序：<span>{{ item.sortno }}</span>
                            </p>
                            <p>
                              状态：<span>{{
                                item.astate ? item.astate : "停用"
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                        <div
                          class="editBtn"
                          @click="handleGo(item.id, 'adverBnnaer', 2)"
                        >
                          编辑banner→
                        </div>
                      </div>
                    </div>
                    <div class="shop_more"></div>
                  </div>
                </template>
                <el-empty
                  description="暂无数据"
                  v-if="!loading && bannerList.length == 0"
                ></el-empty>
              </div>
            </el-tab-pane>
            <el-tab-pane label="首页弹窗广告" name="17">
              <div
                class="list_wrap list_wrap_child"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
                <template v-if="bannerList.length > 0">
                  <div
                    class="item_wrap"
                    v-for="item in bannerList"
                    :key="item.id"
                  >
                    <div class="item_main_wrap flex-rowl">
                      <div class="content_wrap flex-between">
                        <div class="pic_box">
                          <el-image :src="item.pic" fit="contain">
                            <div slot="error" class="image-slot flex-rowc">
                              <i class="iconfont icon-zanwutupian1"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="intro_box flex-rowl">
                          <div class="block">
                            <p>
                              名称：<span>{{ item.topic }}</span>
                            </p>
                            <p>{{ item.siteinstr }}</p>
                            <p>
                              跳转类型：<span>{{ item.gotypestr }}</span>
                            </p>
                          </div>

                          <div class="block">
                            <p>
                              排序：<span>{{ item.sortno }}</span>
                            </p>
                            <p>
                              状态：<span>{{
                                item.astate ? item.astate : "停用"
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <div
                          class="editBtn"
                          @click="handleGo(item.id, 'adverBnnaer', 2)"
                        >
                          编辑banner→
                        </div>
                      </div>
                    </div>
                    <div class="shop_more"></div>
                  </div>
                </template>
                <el-empty
                  description="暂无数据"
                  v-if="!loading && bannerList.length == 0"
                ></el-empty>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="视频广告管理" name="second">
          <!-- <div class="operation_wrap flex-between">
            <div class="select_add flex-rowl" v-if="videoList.length < 3">
              <p class="flex-rowl" @click="handleGo('', 'adverVideo')">
                <i class="iconfont icon-xinzeng"></i> 新增
              </p>
            </div>
          </div> -->
          <div
            class="list_wrap"
            v-loading="videoLoading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="videoList.length > 0">
              <div class="item_wrap" v-for="item in videoList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <video :src="item.videourl" controls></video>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverVideo')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverVideo')"
                    >
                      编辑视频广告→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!videoLoading && videoList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频素材管理" name="third" v-if="false">
          <!-- <div class="operation_wrap flex-between">
            <div class="select_add flex-rowl">
              <p class="flex-rowl" @click="handleGo('', 'adverVideoMeta')">
                <i class="iconfont icon-xinzeng"></i> 新增
              </p>
            </div>
          </div> -->
          <div
            class="list_wrap"
            v-loading="videoMetaLoading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="videoMetaList.length > 0">
              <div
                class="item_wrap"
                v-for="item in videoMetaList"
                :key="item.id"
              >
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <video :src="item.videourl" controls></video>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          视频标题：<span>{{ item.topic }}</span>
                        </p>
                      </div>
                    </div>
                    <div
                      class="editBtn"
                      @click="handleGo(item.videoid, 'adverVideoMeta')"
                    >
                      编辑视频素材→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!videoMetaLoading && videoMetaList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="A型聚合页内容" name="6">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页TopBanner" name="7">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页通栏banner" name="8">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页横屏滚广告区A标题banner" name="9">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页横屏滚广告区A" name="10">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页商品推荐大图A" name="11">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页人气推荐横屏滚动图B" name="12">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页商品推荐大图B" name="13">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页横屏滚广告区B" name="14">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页横屏滚广告区下方标题" name="15">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="B类型聚合页商品推荐大图C" name="16">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="bannerList.length > 0">
              <div class="item_wrap" v-for="item in bannerList" :key="item.id">
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="pic_box">
                      <el-image :src="item.pic" fit="contain">
                        <div slot="error" class="image-slot flex-rowc">
                          <i class="iconfont icon-zanwutupian1"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p>
                          名称：<span>{{ item.topic }}</span>
                        </p>
                        <p>{{ item.siteinstr }}</p>
                        <p>
                          跳转类型：<span>{{ item.gotypestr }}</span>
                        </p>
                      </div>

                      <div class="block">
                        <p>
                          排序：<span>{{ item.sortno }}</span>
                        </p>
                        <p>
                          状态：<span>{{
                            item.astate ? item.astate : "停用"
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <!-- <div class="operation_box flex-colt">
                      <a
                        href="javascript:;"
                        @click="handleGo(item.id, 'adverBnnaer')"
                        >基础信息设置</a
                      >
                    </div> -->
                    <div
                      class="editBtn"
                      @click="handleGo(item.id, 'adverBnnaer', 2)"
                    >
                      编辑banner→
                    </div>
                  </div>
                </div>
                <div class="shop_more"></div>
              </div>
            </template>
            <el-empty
              description="暂无数据"
              v-if="!loading && bannerList.length == 0"
            ></el-empty>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  encryptstringadd,
  getAdverBannerList,
  getAdverVideoList,
  getAdverVideoMateList,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "aManageIndex",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      activeName: "first",
      activeChildName: "2",
      activeLabel: 'banner管理',

      qyguid: "",
      loading: false,
      bannerList: [],

      videoLoading: false,
      videoList: [],

      videoMetaLoading: false,
      videoMetaList: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { menuItem, USERINFO } = this.$store.state;
    this.qyguid = USERINFO.qy.qyguid;
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;
    this.getMenuAuthTwo();
    this.getAdverBannerList();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },
    handleClick(tab) {
      this.activeLabel = tab.label
      this.activeName = tab.name;
      if (tab.name == "second") {
        this.getAdverVideoList();
      } else if (tab.name == "third") {
        this.getAdverVideoMateList();
      } else {
        this.getAdverBannerList();
      }
    },
    handleClickChild(tab) {
      this.activeLabel = tab.label
      this.activeChildName = tab.name;
      this.getAdverBannerList();
    },

    // banner管理
    getAdverBannerList() {
      this.loading = true;
      let { activeName, activeChildName } = this;
      getAdverBannerList({ qyguid: this.qyguid }).then((res) => {
        let sitein = activeName == "first" ? activeChildName : activeName;
        let filterArr = res.list.filter((v) => v.sitein == sitein);
        let originalArray = filterArr;
        let newArray = [];
        if (activeName == "first") {
          if (activeChildName == 2) {
            //banner管理
            newArray = Array(3).fill({});
          } else if (activeChildName == 3) {
            // 商品列表banner
            newArray = Array(6).fill({});
          } else if (activeChildName == 4) {
            // eventbanner
            newArray = Array(1).fill({});
          } else if (activeChildName == 5) {
            // 活动列表页顶部banner
            newArray = Array(1).fill({});
          } else if (activeChildName == 17) {
            // 活动列表页顶部banner
            newArray = Array(1).fill({});
          }
        } else if (activeName == 6) {
          // A型聚合页内容
          newArray = Array(16).fill({});
        } else if (activeName == 7) {
          // B类型聚合页TopBanner
          newArray = Array(7).fill({});
        } else if (activeName == 8) {
          // B类型聚合页通栏banner
          newArray = Array(1).fill({});
        } else if (activeName == 9) {
          // B类型聚合页横屏滚广告区A标题banner
          newArray = Array(1).fill({});
        } else if (activeName == 10) {
          // B类型聚合页横屏滚广告区A
          newArray = Array(6).fill({});
        } else if (activeName == 11) {
          // B类型聚合页商品推荐大图A
          newArray = Array(5).fill({});
        } else if (activeName == 12) {
          // B类型聚合页人气推荐横屏滚动图
          newArray = Array(6).fill({});
        } else if (activeName == 13) {
          // B类型聚合页商品推荐大图B
          newArray = Array(1).fill({});
        } else if (activeName == 14) {
          // B类型聚合页横屏滚广告区B
          newArray = Array(6).fill({});
        } else if (activeName == 15) {
          // B类型聚合页横屏滚广告区下方标题
          newArray = Array(1).fill({});
        } else if (activeName == 16) {
          // B类型聚合页商品推荐大图C
          newArray = Array(4).fill({});
        }

        newArray = [...originalArray, ...newArray.slice(originalArray.length)];
        this.bannerList = newArray;

        this.loading = false;
        return;

        // // 过滤加载页
        // let filterArr1 = res.list.filter((v) => v.sitein == 2);
        // let originalArray = filterArr1;
        // // 创建新数组
        // let newArray = Array(3).fill({});
        // newArray = [...originalArray, ...newArray.slice(originalArray.length)];
        // this.bannerList = newArray;

        // // 商品banner列表
        // let filterArr2 = res.list.filter((v) => v.sitein == 3);
        // let originalArray1 = filterArr2;
        // // 创建新数组
        // let newArray1 = Array(1).fill({});
        // newArray1 = [
        //   ...originalArray1,
        //   ...newArray1.slice(originalArray1.length),
        // ];
        // this.shopBannerList = newArray1;

        // // 商品activity列表
        // let filterArr3 = res.list.filter((v) => v.sitein == 4);
        // let originalArray2 = filterArr3;
        // // 创建新数组
        // let newArray2 = Array(1).fill({});
        // newArray2 = [
        //   ...originalArray2,
        //   ...newArray2.slice(originalArray2.length),
        // ];
        // this.activityBannerList = newArray2;

        // // 活动列表页顶部小banner
        // let filterArr4 = res.list.filter((v) => v.sitein == 5);
        // let originalArray3 = filterArr4;
        // // 创建新数组
        // let newArray3 = Array(1).fill({});
        // newArray3 = [
        //   ...originalArray3,
        //   ...newArray3.slice(originalArray3.length),
        // ];
        // this.topActivityBannerList = newArray3;

        // // A型聚合页内容
        // let filterArr5 = res.list.filter((v) => v.sitein == 6);
        // let originalArray4 = filterArr5;
        // // 创建新数组
        // let newArray4 = Array(16).fill({});
        // newArray4 = [
        //   ...originalArray4,
        //   ...newArray4.slice(originalArray4.length),
        // ];
        // this.topABannerList = newArray4;

        // this.loading = false;
      });
    },

    // video管理
    getAdverVideoList() {
      this.videoLoading = true;
      getAdverVideoList({ qyguid: this.qyguid }).then((res) => {
        let originalArray = res.list;
        // 创建新数组
        let newArray = Array(20).fill({});
        newArray = [...originalArray, ...newArray.slice(originalArray.length)];
        this.videoList = newArray;
        this.videoLoading = false;
      });
    },

    // video素材管理
    getAdverVideoMateList() {
      this.videoMetaLoading = true;
      getAdverVideoMateList({ qyguid: this.qyguid }).then((res) => {
        this.videoMetaList = res.list;
        this.videoMetaLoading = false;
      });
    },

    handleGo(id, name) {
      let {activeName, activeChildName, activeLabel} = this
      let sitein = activeName == 'first' ? activeChildName : activeName
      if (id == "") {
        this.encryptstringadd(name, "");
      } else {
        this.encryptstringadd(name, { id, sitein, activeLabel });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .operation_wrap {
    height: 45px;
  }
  .main_container {
    margin: 15px auto;
    .list_wrap {
      height: 58vh;
      &.list_wrap_child {
        height: 50vh;
      }
    }
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .ercode {
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .pic_box {
    width: 80px;
    height: 80px;
    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>